import React from 'react';
interface DmpLogoProps {
  size?: number;
  tone?: 'light' | 'dark';
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/thuMpBvPfesXhpfBWGgPeg/dhaka-metropolitan-police-seeklogo.png';

/** Official Dhaka Metropolitan Police emblem. On dark surfaces it sits on a white disc for legibility. */
export function DmpLogo({
  size = 40,
  tone = 'dark'
}: DmpLogoProps) {
  const light = tone === 'light';
  return <div className={`relative flex shrink-0 items-center justify-center ${light ? 'rounded-full bg-white' : ''}`} style={{
    width: size,
    height: size,
    padding: light ? size * 0.08 : 0
  }} data-id="element-439" data-mp="3mk5xw01jef48">
      <img src={LOGO_URL} alt="ঢাকা মেট্রোপলিটন পুলিশ লোগো" className="h-full w-full object-contain" draggable={false} data-id="element-440" data-mp="3cu4bdcou14rf" />
    </div>;
}